import * as yup from 'yup'
import { AccountType } from '@/common/types'

const trustAccountTypes = [AccountType.INDIVIDUAL_TRUST, AccountType.COMPANY_TRUST]

export const accountTypeSchema = yup
    .object({
        accountType: yup
            .mixed<AccountType>()
            .oneOf(Object.values(AccountType))
            .required('Please select an account type'),
        isTrust: yup.boolean().required(),
    })
    .test('accountType-isTrust-match', 'Account type must match trust selection', function (value) {
        const { accountType, isTrust } = value

        if (!accountType) {
            return this.createError({
                path: 'accountType',
                message: 'Please select a specific account type',
            })
        }

        // If isTrust is true, accountType must be a trust type
        if (isTrust && !trustAccountTypes.includes(accountType)) {
            return this.createError({
                path: 'accountType',
                message: 'Please select a trust account type (Individual Trust or Company Trust)',
            })
        }

        // If isTrust is false, accountType must be a non-trust type
        if (!isTrust && trustAccountTypes.includes(accountType)) {
            return this.createError({
                path: 'accountType',
                message: 'Trust account types require Trust option to be selected',
            })
        }

        return true
    })
    .required()

export type AccountTypeFormValues = yup.InferType<typeof accountTypeSchema>
